import type { HotelI18n_HotelInfoSettingsPageQuery } from "@/lib/gql/__generated__/graphql";

import type { AutoGeneratorForFormModel } from "@/components/features/_model";

import type { HotelInfoI18nZodSchemaType } from "./validation-schema";

const _excludeKeys = ["companyID", "hotelID", "lang"] as const;
export const excludeKeys = _excludeKeys.map((key) => key);
export type ExcludeKeys = (typeof excludeKeys)[number];

export type HotelSettingsHotelInfoI18nFormModel = AutoGeneratorForFormModel<
	HotelInfoI18nZodSchemaType, //
	ExcludeKeys,
	QueryData
>;

export type QueryData = undefined;

export type ServerModel = HotelI18n_HotelInfoSettingsPageQuery;
